import { TagNeedsReview, TagAutomation } from "../api/models";
import Emails from "../components/Emails";

const EmailsToReview = () => {
    return (
        <Emails title="Review" filterTag={TagNeedsReview} excludeTag={TagAutomation} description="NeedsReview emails without the Automation tag." />
    );
};
export default EmailsToReview;
